import React, { Fragment, useState, useEffect } from 'react'
import { Card, Col, Input, Row, Media, Table, FormGroup } from 'reactstrap'
import ApexCharts from 'react-apexcharts'
import { useBankingDeposits } from '../../hooks/reports/useBankingDeposits'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { ModalAutorizationInvoices } from './ModalAutorizationInvoices';
import { ModalCredit } from './ModalCredit';
import { cedimi } from '../../constant/globalConstantsTypeClients';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import IconDollar from '../../assets/images/ecommerce/invoices-dollar.svg';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Chart } from 'primereact/chart';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primeicons/primeicons.css';
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from 'primereact/tabview';
import { TabMenu } from 'primereact/tabmenu';
import { Tag } from 'primereact/tag';








export const IndexBankingDeposits = () => {


  const {
    // ? REPORT BANKING
    start_date, end_date, handleInputChange, listMovements, indicatorPatient, indicatorAmountInvoice,
    CurrentlyDeposits2, listMovementsInvoice, saveReceived, disabledSaveButton,

    // ? FORMVALUES DEPOSITS
    received, delivere, amount, observation, date_1, date_2, one, range, number_format, validationsSG, GetDeposits,
    totalDepositSend, listDetailBranch, arrayDeposits,
    modalAutorization, toggleModalAutorization, handleInvoices, handleSelecUser, handleSelectPassword, validatePassword, loadingServices, username,

    // ? ONCHANGE CALENDER
    date, onChange, validNotification, tileClassName, handleActions, _validationFinance, detailBranch,

    // ? VIEW CREDIT, FULLY PAID
    type_action,

    // ? DETAIL PAYMENT COMPLEMENT
    dataComplement, totalComplement, isComplement,
    invoiceBranch, monthInvoices, handleSelectBranch, handleSelectMonth, handleSelectAge, getInformationInvoices, listInvoices,
    checkedItems, selectAll, handleCheckboxChange, handleSelectAllChange, saveInvoices,

    // ? CORTESY
    dataCortesy, close, modalProps, modalFullRef, handleReport, companyInfo, formatter, navigateNim, countPatient, cancellPatient,
    valid_view, loadingDeposits, _cliente,

    // ? REPORT DISCOUNT
    headerTemplate, paymentBodyTemplate, reportDiscounts, chartData, countDiscount, exportToExcelDiscount,
    setGlobalFilter, globalFilter, downloadChart, chartRef, loadingDiscount, visible, showModal, hideModal,

    // ? REPORT BONUS
    reportBonus, visibleBonus, showModalBonus, hideModalBonus, countBonus, chartDataBonus, chartOptionsBonus,
    chartBonustRef, handleDownload, setGlobalBonusFilter, globalBonusFilter, exportToExcelBonus,

    // ? REPORT CANCELL
    exportToExcelCancell, formattedData, visibleCancell, showModalCancel, hideModalCancel, setGlobalCancellFilter, globalCancellFilter,
    chartDataCancell, chartOptionsCancell, handleCancellDownload, chartCancellRef,

    // ? REPORT DEVOLUTION
    chartDataDevolution, chartOptionsDevolution, countDevolution, devolutionPatient, visibleDevolution, showModalDevolution, hideModalDevolution,
    exportToExcelDevolution, chartDevolutionRef, handleDevolutionDownload, globalDevolutionFilter, setGlobalDevolutionFilter, loading,

    // ? REPORT BANKING AND MEMBRESIA
    showModalBanking, hideModalBanking, visibleBanking, showModalMembresia, hideModalMembresia, visibleMembresia,
    chartDataReason, chartOptionsReason, groupedByReason,
    _active_micro, amountSanitary, _valid_Finance, handleClosedView,
    modalviewPayment, togglePayment, handlePayment

  } = useBankingDeposits();



  //!TOTAL PRICE
  const [totalCollected, setTotalCollected] = useState(0);
  const [totalGlobal, setTotalGlobal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);


  const formatAmount = (amount) => {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const customBody = (rowData) => {
    return (
      <div
        style={{
          border: "2px solid orange",
          borderRadius: "12px",
          // padding: "1px 4px",
          cursor: "pointer",
          textAlign: "center",
          backgroundColor: "#f8f8f8",
          fontWeight: "bold",
          fontSize: "10px"
        }}
      >
        {rowData.nim}
      </div>
    );
  };

  useEffect(() => {
    const calculateTotals = () => {
      let collected = 0;
      let global = 0;

      detailBranch.flatMap((_branch) =>
        _branch.children.map((_child) => {
          const branchDetails = _child.id && listDetailBranch[_child.id]
            ? listDetailBranch[_child.id].filter(_detail => _detail.id_branch === _child.id && _detail.id_pay_method === 1)
            : [];

          const detail = branchDetails.length > 0 ? branchDetails[0] : null;
          const total = detail ? (detail.amount - _child.amount_collected) : 0;

          collected += _child.amount_collected;
          global += total;

          return _child;
        })
      );

      setTotalCollected(collected);
      setTotalGlobal(global);
    };


    calculateTotals();
  }, [detailBranch, listDetailBranch]);


  useEffect(() => {
    let sum = 0;

    if (listMovements !== null) {
      listMovements.forEach(element => {
        if (element?.id_pay_method === 29 || element.id_pay_method === 31 || element.id_pay_method === 7) {
          return;
        }

        sum += element.amount;
      });

      setTotalAmount(sum);
    }
  }, [listMovements])

  const paymentMethods = {
    1: "Efectivo",
    2: "Tarjeta de Credito",
    4: "Tarjeta de Débito",
    8: "Transferencia electronica",
    0: "Otro"
  };

  const filteredInvoices = selectedPaymentMethod
    ? listInvoices.filter(invoice => {
      const payMethod = Array.isArray(invoice.pay_methods) ? invoice.pay_methods[0] : invoice.pay_methods;
      return payMethod === selectedPaymentMethod;
    })
    : listInvoices;

  const totalAmount2 = filteredInvoices.reduce((sum, invoice) => sum + (invoice.amount ?? 0), 0);

  const invoicesAmount2 = (
    <tr style={{ backgroundColor: 'rgb(1 12 18)', height: '20px' }} className='sticky-footer'>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td className='label-finance'>Totales Globales:</td>
      <td className='label-finance'>
        ${number_format(totalAmount2 ?? 0, 2)}
      </td>

    </tr>
  );


  // ? CHART   ------new 
  const paymentMethods2 = {};

  filteredInvoices.forEach(invoice => {
    const payMethod = Array.isArray(invoice?.pay_methods) ? invoice?.pay_methods[0] : invoice?.pay_methods;
    let methodName;

    switch (payMethod) {
      case 1:
        methodName = 'Efectivo';
        break;
      case 2:
        methodName = 'Tarjeta de Crédito';
        break;
      case 4:
        methodName = 'Tarjeta de Débito';
        break;
      case 8:
        methodName = 'Transferencia Electrónica';
        break;
      case 10:
        methodName = 'Crédito';
        break;
      case 27:
        methodName = 'Método PPD';
        break;
      default:
        methodName = 'Mercado Pago';
        break;
    }

    paymentMethods2[methodName] = (paymentMethods2[methodName] || 0) + invoice.amount;
  });

  const labels = Object.keys(paymentMethods2);

  const chartOptions = {
    chart: {
      type: 'donut',
      height: 350,
    },
    labels: labels,
    plotOptions: {
      pie: {
        donut: {
          size: '60%',
          total: {
            show: false,
          },
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `$${val.toLocaleString()}`,
      },
      style: {
        fontSize: '12px',
        fontFamily: 'Arial, sans-serif',
      },
    },
    fill: {
      colors: ['#FFC107', '#0079C7', '#07e357', '#f55463', '#D0E6A5', '#FFC107'],
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: '100%',
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    dataLabels: {
      enabled: false,
    },
  };

  var _ticket = number_format(totalAmount / indicatorPatient, 2)

  // ? CONFIGURATION TOTAL AMOUNT SERVICE THE AMOUNT 
  const leftContents = (
    <>
      <Button
        label="Ingreso Total "
        icon={<img src={IconDollar} alt="ícono dólar" style={{ width: '2.2rem' }} />}
        className="p-button-text p-button-primary"
      >
        {
          _valid_Finance === "True" ?
            <b className=" txt-primary"> &nbsp;&nbsp;${number_format(totalAmount - totalCollected, 2)}</b>
            :
            <b className=" txt-secondary">&nbsp;&nbsp; ${number_format(totalAmount, 2)}</b>
        }
      </Button>
      <Button
        label="Total en cuenta"
        icon={<img src={IconDollar} alt="ícono dólar" style={{ width: '2.2rem' }} />}
        className="p-button-text p-button-primary"
      >
        <b className=" txt-info">&nbsp;&nbsp; ${number_format(totalDepositSend, 2)}</b>
      </Button>
      {
        _valid_Finance === "True" ? null :
          <Button
            label="Ticket promedio"
            icon={<img src={IconDollar} alt="ícono dólar" style={{ width: '2.2rem' }} />}
            className="p-button-text p-button-success"
          >
            <b className=" txt-success">&nbsp;&nbsp;${_ticket} </b>

          </Button>
      }

      {
        <Button
          disabled={loadingDiscount ? true : false}
          label="Descuentos"
          icon={<img src={IconDollar} alt="ícono dólar" style={{ width: '2.2rem' }} />}
          className="p-button-text p-button-danger"
          onClick={showModal}
        >
          {
            loadingDiscount ?
              <>
                &nbsp;&nbsp;<i className="pi pi-spin pi-spinner" style={{ fontSize: "1.2rem", color: "red" }}></i>
              </>
              :
              <>
                &nbsp;&nbsp;${countDiscount}
              </>
          }
        </Button>
      }
      {
        _cliente === cedimi && <Button
          label="Bonificaciones"
          icon={<img src={IconDollar} alt="ícono dólar" style={{ width: '2.2rem' }} />}
          className="p-button-text p-button-danger"
          onClick={showModalBonus}
        >
          &nbsp;&nbsp;${countBonus}
        </Button>
      }
      <Button
        label="Devoluciones"
        icon={<img src={IconDollar} alt="ícono dólar" style={{ width: '2.2rem' }} />}
        className="p-button-text p-button-warning"
        onClick={showModalDevolution}
      >
        &nbsp;&nbsp;${countDevolution}
      </Button>
      {
        (_active_micro === "True" && _cliente !== cedimi) &&
        <Button
          label="Total Microsanitaria"
          icon={<img src={IconDollar} alt="ícono dólar" style={{ width: '2.2rem' }} />}
          className="p-button-text p-button-secondary"
          onClick={showModalBonus}
        >
          &nbsp;&nbsp;${amountSanitary}
        </Button>
      }
      {
        (_active_micro === "True" && _cliente !== cedimi) &&
        <Button
          label="Total Clinicos"
          icon={<img src={IconDollar} alt="ícono dólar" style={{ width: '2.2rem' }} />}
          className="p-button-text p-button-primary"
          onClick={showModalBonus}
        >
          &nbsp;&nbsp;${(
            ((typeof totalAmount === 'string' ? parseFloat(totalAmount.replace(/,/g, '')) : totalAmount) -
              (typeof amountSanitary === 'string' ? parseFloat(amountSanitary.replace(/,/g, '')) : amountSanitary))
              .toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
          )}
        </Button>
      }
    </>
  );

  // ? MENU
  const items =
    [
      { label: 'Dashboard', icon: 'pi pi-chart-bar' },
      { label: 'Deposito Bancario', icon: 'pi pi-id-card' },
      { label: 'Pendientes a facturar', icon: 'pi pi-file-pdf' },
    ]

  // * STYLES DATA TABLE
  const headerStyle = {
    backgroundColor: "#1d5b83",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "11px",
    borderRight: "1px solid #fff",
    borderBottom: "2px solid #fff",
  };

  const cellStyle = {
    fontSize: "11px",
    padding: "5px",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",

  };

  const centerStyle = {
    ...cellStyle,
    textAlign: "center",
    zIndex: 2
  };

  // ? CONFIGURATION TAG
  const tagInfo = (rowData) => {
    if (rowData.uuid === null) {
      return <Tag style={{ backgroundColor: "#f8d62b", width: "82px", fontSize: "10px", }} className="mr-2" value={rowData.folio}  ></Tag>;
    }
    return <Tag className="mr-2 " style={{ width: "82px", fontSize: "10px", }} severity='secondary' value={rowData.folio}   ></Tag>;
  };

  // ? CONFIGURATION TAG INVOICE
  const tagInfoInvoice = (rowData) => {
    if (rowData.uuid === null) {
      return <Tag style={{ backgroundColor: "#f8d62b", width: "82px", fontSize: "10px", }} className="mr-2" value={rowData.folioReceptor}  ></Tag>;
    }
    return <Tag className="mr-2 " style={{ width: "82px", fontSize: "10px", }} severity='secondary' value={rowData.folioReceptor}   ></Tag>;
  };

  // ? CONFIGURATION AMOUNT COMPLEMENT
  const SumTotal = dataComplement.reduce((acc, r) => acc + (r.payment_amount ?? 0), 0);

  const footerStyle =
  {
    backgroundColor: '#000',
    color: '#fff',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '0.75rem',
    padding: '4px',
  };



  return (
    <Fragment>
      {
        <ModalAutorizationInvoices
          {
          ...{ modalAutorization, toggleModalAutorization, saveInvoices, handleSelecUser, handleSelectPassword, validatePassword, loadingServices, username }
          }

        />
      }

      {
        // ? DIALOG PAYMENT
      }
      <Dialog
        header="Ingresos de otros meses"
        visible={modalviewPayment}
        modal
        dismissableMask
        onHide={togglePayment}
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}
      >
        <Col sm="12" className='pb-3 pt-4 p-l-0 p-r-0'>
          <Col sm="7" className='pb-3 p-l-0' >
            <div
              style={{
                color: "#856404",
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd",
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              {"Registro de los pagos realizados de las facturas PPD efectuados en este periodo." ?? "---"}
            </div>
          </Col>
          <DataTable
            value={dataComplement}
            dataKey="idBranch"
            paginator
            rows={10}
            rowsPerPageOptions={[10, 50, 100, 200]}
            responsiveLayout="scroll"
            emptyMessage={
              <div className="text-center">
                <img
                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                  style={{ width: "45%" }}
                  alt="Sin resultados"
                />
                <br />
                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                  No hay ingresos de otros meses.
                </p>
              </div>
            }
          >
            <Column header="#" sortable body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="payment_date" sortable header="Fecha" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column header="Folio" body={(row) => tagInfo(row)} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="nameBussines" sortable header="Receptor" headerStyle={headerStyle} style={centerStyle} footer="Totales:" footerStyle={footerStyle} />
            <Column field="payment_amount" sortable header="Monto" headerStyle={headerStyle} style={centerStyle} footer={`$${number_format(SumTotal, 2)}`} footerStyle={footerStyle} />
            <Column field="uuid" sortable header="UUID" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column header="Factura asociada" body={(row) => tagInfoInvoice(row)} headerStyle={headerStyle} style={centerStyle} footer="" />
          </DataTable>
        </Col>

      </Dialog>
      {
        // ? DIALOG DISCOUNT
      }
      <Dialog
        header={<label className='f-w-600'>Total de descuentos: <b className='txt-info' >{reportDiscounts.length ?? 0}</b>&nbsp;&nbsp;&nbsp;&nbsp; Monto de descuento: <b className='txt-danger' >&nbsp;&nbsp;${countDiscount}</b> </label>}
        visible={visible}
        onHide={hideModal}
        maximizable
        maximized

        style={{
          width: '50vw',
          position: 'fixed',
          left: 1,
          top: '20px',
          bottom: '20px',
        }}
        breakpoints={{ '960px': '50vw', '600px': '75vw' }}
      >
        <Col sm="12" className='p-l-0 p-r-0'>
          <Row>
            <Col sm="8" className='p-l-0 p-r-0'>
              <DataTable
                className="data-table"
                globalFilter={globalFilter}
                value={reportDiscounts}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                emptyMessage={
                  <div className="text-center">
                    <img
                      src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                      style={{ width: "25%" }}
                      alt="Sin resultados"
                    />
                    <br />
                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                  </div>
                }
                header={
                  <Col sm="12" className='p-l-0 p-r-0'>
                    <Row>
                      <Col sm="7">
                      </Col>
                      <Col sm="1">
                        <Button icon="pi pi-file-excel"
                          data-pr-tooltip="Descargar Reporte"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}

                          className="p-button-success" onClick={() => exportToExcelDiscount(reportDiscounts)} />
                      </Col>
                      <Col sm="1">
                        <Button
                          icon="pi pi-chart-bar"
                          className="p-button-info"
                          onClick={downloadChart}
                          data-pr-tooltip="Descargar gráfica"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                        />
                        +
                      </Col>
                      <Col sm="2">
                        <span className="p-input-icon-left">
                          <InputText
                            type="search"
                            className="pl-6"
                            onInput={(e) => setGlobalFilter(e.target.value)}
                            style={{ width: "auto" }}
                          />
                          <i className="pi pi-search" />

                        </span>
                      </Col>
                    </Row>
                  </Col>
                }
              >
                <Column
                  header="#"
                  body={(rowData, { rowIndex }) => rowIndex + 1}
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    width: "5%",
                  }}
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                />

                <Column
                  field="nim"
                  header="Nim"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={customBody}
                />
                <Column
                  field="name_branches"
                  header="Sucursal"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="name"
                  header="Paciente"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="age"
                  header="Edad"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="name_Preloaded_discount"
                  header="Descuento aplicado"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />


                <Column
                  field="amountDiscount"
                  header="Total de descuento"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={(rowData) => `$${formatAmount(rowData.amountDiscount)}`}
                />

                <Column
                  field="percentagePreloaded_discount"
                  header="% Aplicado"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
              </DataTable>

            </Col>
            <Col sm="4" className="p-r-0">
              <Col sm="12">
                <div className="mt-3" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                  {chartData?.labels
                    ?.filter((_, index) => chartData.datasets[0]?.data[index] > 0)
                    .map((name, index) => ({
                      name,
                      total: chartData.datasets[0]?.data[index],
                      count: chartData.datasets[1]?.data[index],
                      index,

                    }))
                    .sort((a, b) => b.total - a.total)
                    .map((item, index) => (
                      <div
                        key={item.index}
                        style={{
                          padding: '0.7rem 1rem',
                          borderBottom: '1px solid #ddd',
                          fontSize: '14px',
                        }}
                      >
                        <strong>{index + 1}. {item.name}</strong><br />
                        <span>Total Descuento:</span> <span className="text-success">${item.total.toFixed(2)}</span><br />
                        <span>Veces Aplicado:</span> <span className="text-primary">{item.count}</span>
                      </div>
                    ))}
                </div>

              </Col>
            </Col>
          </Row>
        </Col>
        <Row>
          <Col sm="12" >
            <div

            >
              <Chart
                ref={chartRef}
                type="bar"
                data={chartData}
                options={chartOptions}
              />
            </div>
          </Col>
        </Row>


      </Dialog>
      {
        // ? DIALOG BONUS
      }
      <Dialog
        header={<label className='f-w-600'>Total de bonificaciones: <b className='txt-info' >{reportBonus.length ?? 0}</b>&nbsp;&nbsp;&nbsp;&nbsp; Monto de bonificaciones: <b className='txt-danger' >&nbsp;&nbsp;${countBonus}</b> </label>}
        visible={visibleBonus}
        onHide={hideModalBonus}
        maximizable
        maximized
        style={{
          width: '50vw',
          position: 'fixed',
          left: 1,
          top: '20px',
          bottom: '20px',
        }}
        breakpoints={{ '960px': '50vw', '600px': '75vw' }}
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}

      >


        <Col sm="12" className='p-l-0 p-r-0' >
          <Row>
            <Col sm="8" className='p-l-0 p-r-0' >
              <DataTable
                className="data-table"
                globalFilter={globalBonusFilter}
                value={reportBonus}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                emptyMessage={
                  <div className="text-center">
                    <img
                      src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                      style={{ width: "25%" }}
                      alt="Sin resultados"
                    />
                    <br />
                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                  </div>
                }
                header={
                  <Col sm="12" className='p-l-0 p-r-0'>
                    <Row>
                      <Col sm="6">
                      </Col>
                      <Col sm="1">
                        <Button icon="pi pi-file-excel"
                          data-pr-tooltip="Descargar Reporte"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}

                          className="p-button-success" onClick={() => exportToExcelBonus(reportBonus)} />

                      </Col>
                      <Col sm="1">
                        <Button
                          icon="pi pi-chart-bar"
                          className="p-button-info"
                          onClick={handleDownload}
                          data-pr-tooltip="Descargar gráfica"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                        />
                      </Col>
                      <Col sm="2">
                        <span className="p-input-icon-left">
                          <InputText
                            type="search"
                            className="pl-6"
                            onInput={(e) => setGlobalBonusFilter(e.target.value)}
                            style={{ width: "auto" }}
                          />
                          <i className="pi pi-search" />

                        </span>
                      </Col>
                    </Row>
                  </Col>
                }
              >
                <Column
                  header="#"
                  body={(rowData, { rowIndex }) => rowIndex + 1}
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    width: "5%",
                  }}
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                />

                <Column
                  field="nim"
                  header="Nim"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={customBody}

                />
                <Column
                  field="name_branches"
                  header="Sucursal"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="namePatient"
                  header="Paciente"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />


                <Column
                  field="nameMethod"
                  header="Metodo de pago"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="amount"
                  header="Monto"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={(rowData) => `$${formatAmount(rowData.amount)}`}

                />
                <Column
                  field="fech"
                  header="Fecha"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="user_responsible"
                  header="Responsable"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
              </DataTable>
            </Col>
            <Col sm="4" className='p-r-0' >
              <Chart type="bar" data={chartDataBonus} ref={chartBonustRef} options={chartOptionsBonus} />
              <div className="mt-3">
                {chartDataBonus?.labels?.map((name, index) => (
                  <div
                    key={index}
                    style={{
                      padding: '0.7rem 1rem',
                      borderBottom: '1px solid #ddd',
                      fontSize: '14px',
                    }}
                  >
                    <strong>{index + 1}. {name}</strong><br />
                    <span>Total Bonificado:</span> <span className="text-success">${chartDataBonus.datasets[0].data[index].toFixed(2)}</span><br />
                    <span>Veces Aplicado:</span> <span className="text-primary">{chartDataBonus.datasets[1].data[index]}</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Col>





      </Dialog>
      {
        // ? DIALOG CANCELL
      }
      <Dialog
        header={
          <label className='f-w-600'>
            Total de cancelaciones: <b className='txt-info'>{cancellPatient.length}</b>&nbsp;&nbsp;&nbsp;&nbsp;
            Monto de cancelaciones: <b className='txt-danger'>&nbsp;&nbsp;${countPatient}</b>
          </label>
        }
        visible={visibleCancell}
        onHide={hideModalCancel}
        maximizable
        maximized={true}
        style={{
          width: '90vw',
          position: 'fixed',
          left: 1,
          top: '20px',
          bottom: '20px',
        }}
        breakpoints={{ '1060px': '80vw', '800px': '85vw' }}
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
        }}
      >
        <div>
          <Col sm="12" className='p-l-0 p-r-0' >
            <TabView className='pl-0 pr-0' >
              <TabPanel header="Reporte" className='pl-0 pr-0' >
                <DataTable
                  className="data-table"
                  globalFilter={globalCancellFilter}
                  value={cancellPatient}
                  paginator
                  rows={6}
                  rowsPerPageOptions={[6, 20, 50, 100]}
                  emptyMessage={
                    <div className="text-center">
                      <img
                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                        style={{ width: "25%" }}
                        alt="Sin resultados"
                      />
                      <br />
                      <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                    </div>
                  }
                  header={
                    <Col sm="12" className='p-l-0 p-r-0'>
                      <Row>
                        <Col sm="6">
                        </Col>
                        <Col sm="1">
                          <Button icon="pi pi-file-excel"
                            data-pr-tooltip="Descargar Reporte"
                            style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}

                            className="p-button-success" onClick={() => exportToExcelCancell(cancellPatient)} />

                        </Col>
                        <Col sm="1">
                          <Button
                            icon="pi pi-chart-bar"
                            className="p-button-info"
                            onClick={handleCancellDownload}
                            data-pr-tooltip="Descargar gráfica"
                            style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                          />
                        </Col>
                        <Col sm="2">
                          <span className="p-input-icon-left">
                            <InputText
                              type="search"
                              className="pl-6"
                              onInput={(e) => setGlobalCancellFilter(e.target.value)}
                              style={{ width: "auto" }}
                            />
                            <i className="pi pi-search" />

                          </span>
                        </Col>
                      </Row>
                    </Col>
                  }
                >
                  <Column
                    header="#"
                    body={(rowData, { rowIndex }) => rowIndex + 1}
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      width: "5%",
                    }}
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                  />

                  <Column
                    field="nim"
                    header="Nim"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                    body={customBody}
                  />
                  <Column
                    field="branch"
                    header="Sucursal"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />
                  <Column
                    field="name_patient"
                    header="Paciente"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />

                  <Column
                    field="type"
                    header="Tipo de ingreso"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />
                  <Column
                    field="amount"
                    header="Monto"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                    body={(rowData) => `$${formatAmount(rowData.amount)}`}

                  />
                  <Column
                    field="reazon_cancellation"
                    header="Motivo de cancelación"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />


                  <Column
                    field="user_autorized"
                    header="Responsable"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />
                  <Column
                    field="date_cancellation"
                    header="Fecha de cancalación"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />

                </DataTable>
              </TabPanel>
              <TabPanel header="Graficas" className='pl-0 pr-0'>
                <Row style={{ scrollBehavior: "smooth", transform: "scale(0.7)", width: "135%", transformOrigin: "top left" }} >
                  <Col sm="6">
                    <div className="card">
                      <h5 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "20px" }}>
                        Cancelaciones por Responsable
                      </h5>
                      <Chart
                        type="bar"
                        data={chartDataCancell}
                        options={chartOptionsCancell}
                        ref={chartCancellRef}
                      />
                      <div className="table-responsive mt-4">
                        <table className="table table-striped table-bordered" style={{ fontSize: "13px" }}>
                          <thead style={{ backgroundColor: "#1d5b83", color: "#fff" }}>
                            <tr>
                              <th style={{ textAlign: "left", color: "#fff" }}>Responsable</th>
                              <th style={{ textAlign: "center", color: "#fff" }}>Veces Aplicadas</th>
                              <th style={{ textAlign: "right", color: "#fff" }}>Total Cancelado ($)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chartDataCancell?.labels?.map((name, index) => (
                              <tr key={index}>
                                <td>{name}</td>
                                <td style={{ textAlign: "center" }}>
                                  {chartDataCancell.datasets[1].data[index]}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  ${chartDataCancell.datasets[0].data[index].toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                  <Col sm="6">
                    <div className="card">
                      <h5 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "20px" }}>
                        Total Cancelado por Motivo
                      </h5>
                      <Chart type="bar" data={chartDataReason} options={chartOptionsReason} />
                      <div className="table-responsive mt-4">
                        <table className="table table-striped table-bordered" style={{ fontSize: "13px" }}>
                          <thead style={{ backgroundColor: "#1d5b83", color: "#fff" }}>
                            <tr>
                              <th style={{ textAlign: "left", color: "#fff" }}>Motivo de cancelación</th>
                              <th style={{ textAlign: "center", color: "#fff" }}>Cantidad de veces</th>
                              <th style={{ textAlign: "right", color: "#fff" }}>Total cancelado ($)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(groupedByReason).map(([reason, { totalAmount, count }]) => (
                              <tr key={reason}>
                                <td>{reason}</td>
                                <td style={{ textAlign: "center" }}>{count}</td>
                                <td style={{ textAlign: "right" }}>${totalAmount.toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </TabPanel>
            </TabView>
          </Col>
        </div>
      </Dialog>
      {
        // ? DIALOG DEVOLUTION
      }
      <Dialog
        header={<label className='f-w-600'>Total de devoluciones: <b className='txt-info' >{devolutionPatient.length}</b>&nbsp;&nbsp;&nbsp;&nbsp; Monto de devoluciones: <b className='txt-danger' >&nbsp;&nbsp;${countDevolution}</b> </label>}
        visible={visibleDevolution}
        onHide={hideModalDevolution}
        modal
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}
      >
        <Col sm="12" className='p-l-0 p-r-0' >
          <Col sm="6" className='pb-3 p-l-0' >
            <div
              style={{
                color: "#856404",
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd",
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              {"Reporte de pacientes que se efectuo una devolución en sus estudios" ?? "---"}
            </div>
          </Col>
          <Row>
            <Col sm="12" md="8" lg="8" className='p-l-0 p-r-0' >
              <DataTable
                className="data-table"
                globalFilter={globalDevolutionFilter}
                value={devolutionPatient}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                emptyMessage={
                  <div className="text-center">
                    <img
                      src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                      style={{ width: "25%" }}
                      alt="Sin resultados"
                    />
                    <br />
                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                  </div>
                }
                header={
                  <Col sm="12" className='p-l-0 p-r-0'>
                    <Row>
                      <Col sm="6">
                      </Col>
                      <Col sm="1">
                        <Button icon="pi pi-file-excel"
                          data-pr-tooltip="Descargar Reporte"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                          className="p-button-success" onClick={() => exportToExcelDevolution(devolutionPatient)} />

                      </Col>
                      <Col sm="1">
                        <Button
                          icon="pi pi-chart-bar"
                          className="p-button-info"
                          onClick={handleDevolutionDownload}
                          data-pr-tooltip="Descargar gráfica"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                        />
                      </Col>
                      <Col sm="2">
                        <span className="p-input-icon-left">
                          <InputText
                            type="search"
                            className="pl-6"
                            onInput={(e) => setGlobalDevolutionFilter(e.target.value)}
                            style={{ width: "auto" }}
                          />
                          <i className="pi pi-search" />

                        </span>
                      </Col>
                    </Row>
                  </Col>
                }
              >
                <Column
                  header="#"
                  body={(rowData, { rowIndex }) => rowIndex + 1}
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    width: "5%",
                  }}
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                />

                <Column
                  field="nim"
                  header="Nim"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={customBody}
                />
                <Column
                  field="branch"
                  header="Sucursal"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="name_patient"
                  header="Paciente"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />

                <Column
                  field="type"
                  header="Tipo de ingreso"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="amount"
                  header="Monto"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={(rowData) => `$${formatAmount(rowData.amount)}`}

                />
                <Column
                  field="reazon_cancellation"
                  header="Motivo de devolución"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />


                <Column
                  field="user_autorized"
                  header="Responsable"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="date_cancellation"
                  header="Fecha de devolución"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />

              </DataTable>
            </Col>
            <Col sm="12" md="4" lg="4" className='p-r-0' >
              <Chart type="bar" data={chartDataDevolution} ref={chartDevolutionRef} options={chartOptionsDevolution} />
              <div className="mt-3">
                {chartDataDevolution?.labels?.map((name, index) => (
                  <div
                    key={index}
                    style={{
                      padding: '0.7rem 1rem',
                      borderBottom: '1px solid #ddd',
                      fontSize: '14px',
                    }}
                  >
                    <strong>{index + 1}. {name}</strong><br />
                    <span>Total Devuelto:</span> <span className="text-success">${chartDataDevolution.datasets[0].data[index].toFixed(2)}</span><br />
                    <span>Veces Aplicado:</span> <span className="text-primary">{chartDataDevolution.datasets[1].data[index]}</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Col>
      </Dialog>
      {
        // ? BANKING
      }
      <Dialog
        header={<label className='f-w-600'>Deposito bancario</label>}
        visible={visibleBanking}
        onHide={hideModalBanking}
        modal
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}
      >

        <Col sm="12" className='pb-3 pt-4 p-l-0 p-r-0'>
          <Col sm="6" className='pb-3 p-l-0 ' >
            <div
              style={{
                color: "#856404",
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd",
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              {"Registros generados de los depositos realizados." ?? "---"}
            </div>
          </Col>

          <DataTable
            value={arrayDeposits}
            dataKey="idBranch"
            paginator
            rows={10}
            rowsPerPageOptions={[10, 50, 100, 200]}
            responsiveLayout="scroll"
            emptyMessage={
              <div className="text-center">
                <img
                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                  style={{ width: "45%" }}
                  alt="Sin resultados"
                />
                <br />
                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                  No hay cortesias aplicadas.
                </p>
              </div>
            }
          >
            <Column header="#" sortable body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="date_1" sortable header="Fecha" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="user_delivere" sortable header="Usuario que entrego" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="user_received" sortable header="Usuario que recibio" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="observation" sortable header="Observación" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="amount" sortable header="Monto" body={(rowData) => `$${number_format(rowData?.amount ?? 0, 2)}`}
              headerStyle={headerStyle} style={centerStyle} footer={`$${number_format(arrayDeposits.reduce((acc, curr) => acc + (curr?.amount ?? 0), 0), 2)}`} footerStyle={footerStyle} />
          </DataTable>
        </Col>
      </Dialog>
      {
        // ? MEMBRESIA
      }
      <Dialog
        header={<label className='f-w-600'>Membresia</label>}
        visible={visibleMembresia}
        onHide={hideModalMembresia}
        modal
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}
      >
        <Col sm="12" className='pb-3 pt-4 p-l-0 p-r-0'>
          <Col sm="6" className='pb-3 p-l-0' >
            <div
              style={{
                color: "#856404",
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd",
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              {"Registros que no suman a los totales globales en indicadores." ?? "---"}
            </div>
          </Col>

          <DataTable
            value={dataCortesy}
            dataKey="idBranch"
            paginator
            rows={10}
            rowsPerPageOptions={[10, 50, 100, 200]}
            responsiveLayout="scroll"
            emptyMessage={
              <div className="text-center">
                <img
                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                  style={{ width: "45%" }}
                  alt="Sin resultados"
                />
                <br />
                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                  No hay cortesias aplicadas.
                </p>
              </div>
            }
          >
            <Column header="#" sortable body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="date" sortable header="Fecha" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="nim" sortable header="Nim" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="namePatient" sortable header="Paciente" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="amount" sortable header="Monto" body={(rowData) => `$${number_format(rowData?.amount ?? 0, 2)}`} headerStyle={headerStyle} style={centerStyle} footer={`$${number_format(dataCortesy.reduce((acc, curr) => acc + (curr?.amount ?? 0), 0), 2)}`} footerStyle={footerStyle} />
          </DataTable>
        </Col>
      </Dialog>
      { // ? MAIN DIALOG
        <div className='container-global-zoom' style={{ display: "flex", flexDirection: "column", height: "100%" }} >
          <Col sm="12" style={{ marginTop: "2px" }}>
            <TabMenu
              model={items}
              activeIndex={activeIndex}
              onTabChange={(e) => {
                setActiveIndex(e.index);
              }}
              className="custom-tabmenu full-width custom-tabmenu-orange"
              style={{ marginBottom: "15px" }}
            />
            <Card>

              {activeIndex === 0 && (
                <Col sm="12"   >
                  {
                    !valid_view &&
                    <Row className={type_action === "A" ? 'dashboard-sec box-col-12' : (["F", "R", "C", "D"].includes(type_action) ? 'd-none' : 'dashboard-sec box-col-12')} >
                      <Col sm="12" style={{ textAlign: "center" }}>
                        {
                          loading && <i className="fa fa-spin fa-spinner font-primary f-46"></i>
                        }
                      </Col>
                      <Col sm="12" className='p-l-0 p-r-0' >
                        <Row>
                          <Col sm="12" className='p-l-0 p-r-0' >
                            <div style={{ height: "420px" }} >
                              <Row>
                                <Col sm="2">
                                  <Col sm="12" className='pt-3' style={{
                                    display: (
                                      listMovements?.some(movement => movement.id_pay_method === 28 && movement.amount !== null && movement.amount !== undefined) ||
                                      listMovementsInvoice?.some(movement => movement.id_pay_method === 28 && movement.amount !== null && movement.amount !== undefined)) ? 'block' : 'none'
                                  }}>
                                    <Col sm="12" className='col-selected-1' style={{ border: "solid 1px #ecf3fa", height: "60px" }}>
                                      <Row className='pt-2' >
                                        <Col sm="3" className='pt-2'>
                                          <div className='card-validateFinance-MP '>
                                            <b className='f-12'>F.D</b>
                                          </div>
                                        </Col>
                                        <Col sm="9">
                                          {listMovements?.map((movement) => {
                                            if (movement.id_pay_method === 28 && movement.amount !== null && movement.amount !== undefined) {
                                              return (
                                                <div key={movement.id_pay_method} className='txt-primary'>
                                                  <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                                </div>
                                              );
                                            }
                                            return null;
                                          })}
                                          {listMovementsInvoice?.map((movement) => {
                                            if (movement.id_pay_method === 28 && movement.amount !== null && movement.amount !== undefined) {
                                              return (
                                                <div key={movement.id_pay_method} className='txt-danger pt-2'>
                                                  <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                                </div>
                                              );
                                            }
                                            return null;
                                          })}
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Col>
                                  <Col sm="12" className='pt-3' style={{
                                    display: (
                                      listMovements?.some(movement => movement.id_pay_method === 7 && movement.amount !== null && movement.amount !== undefined) ||
                                      listMovementsInvoice?.some(movement => movement.id_pay_method === 7 && movement.amount !== null && movement.amount !== undefined)) ? 'block' : 'none'
                                  }}>
                                    <Col sm="12" className='col-selected-1' style={{ border: "solid 1px #ecf3fa", height: "60px" }}>
                                      <Row className='pt-2' >
                                        <Col sm="3" className='pt-2'>
                                          <div className='card-validateFinance-MP '>
                                            <b className='f-12'>CH</b>
                                          </div>
                                        </Col>
                                        <Col sm="9">
                                          {listMovements?.map((movement) => {
                                            if (movement.id_pay_method === 7 && movement.amount !== null && movement.amount !== undefined) {
                                              return (
                                                <div key={movement.id_pay_method} className='txt-primary'>
                                                  <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                                </div>
                                              );
                                            }
                                            return null;
                                          })}

                                        </Col>
                                      </Row>
                                    </Col>
                                  </Col>
                                </Col>
                                <Col sm="2" className='pt-3 pl-4' style={{
                                  display: (
                                    listMovements?.some(movement => movement.id_pay_method === 1 && movement.amount !== null && movement.amount !== undefined) ||
                                    listMovementsInvoice?.some(movement => movement.id_pay_method === 1 && movement.amount !== null && movement.amount !== undefined)
                                  ) ? 'block' : 'none'
                                }}>
                                  <Col className='col-selected-1' sm="12" style={{ border: "solid 1px #ecf3fa", height: "60px" }}>
                                    <Row className='pt-2'>
                                      <Col sm="3" className='pt-2'>
                                        <div className='card-validateFinance-E'>
                                          <b className='f-14'>E</b>
                                        </div>
                                      </Col>
                                      <Col sm="9">
                                        {listMovements?.map((movement) => {
                                          if (movement.id_pay_method === 1 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-primary'>
                                                {_valid_Finance === "True" ?
                                                  <div>
                                                    {
                                                      detailBranch.length === 0 ?
                                                        <b style={{ fontSize: "10px" }} className=' f-w-600 txt-primary'>${number_format(movement.amount, 2)}</b>

                                                        :
                                                        <b style={{ fontSize: "10px" }} className=' f-w-600 txt-primary'>${number_format(totalGlobal, 2)}</b>

                                                    }
                                                  </div>

                                                  :
                                                  <div>
                                                    <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                                    <br />
                                                    {_validationFinance && <b style={{ fontSize: "11px" }} > ${number_format(totalGlobal, 2)}</b>}
                                                  </div>
                                                }
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                        {listMovementsInvoice?.map((movement) => {
                                          if (movement.id_pay_method === 1 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-danger pt-2'>
                                                <b style={{ fontSize: "11px" }} > ${number_format(movement.amount, 2)}</b>
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                      </Col>
                                    </Row>
                                  </Col>
                                </Col>
                                <Col sm="2" className='pt-3' style={{
                                  display: (
                                    listMovements?.some(movement => movement.id_pay_method === 10 && movement.amount !== null && movement.amount !== undefined) ||
                                    listMovementsInvoice?.some(movement => movement.id_pay_method === 10 && movement.amount !== null && movement.amount !== undefined)) ? 'block' : 'none'
                                }}>
                                  <Col sm="12" className='col-selected' style={{ border: "solid 1px #ecf3fa", height: "60px" }}>
                                    <Row className='pt-2' >
                                      <Col sm="3" className='pt-2'>
                                        <div onClick={() => handleReport()} className='card-validateFinance-C pointer'>
                                          <b className='f-14'>C</b>
                                        </div>
                                      </Col>
                                      <Col sm="9">
                                        {listMovements?.map((movement) => {
                                          if (movement.id_pay_method === 10 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-primary '>
                                                {
                                                  _validationFinance === "True" ?
                                                    <b style={{ fontSize: "11px" }}> ${number_format(totalGlobal, 2)}</b>
                                                    :
                                                    <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                                }
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                        {listMovementsInvoice?.map((movement) => {
                                          if (movement.id_pay_method === 10 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-danger pt-2'>
                                                <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                      </Col>
                                    </Row>
                                  </Col>
                                </Col>
                                <Col sm="2" className='pt-3' style={{
                                  display: (
                                    listMovements?.some(movement => movement.id_pay_method === 2 && movement.amount !== null && movement.amount !== undefined) ||
                                    listMovementsInvoice?.some(movement => movement.id_pay_method === 2 && movement.amount !== null && movement.amount !== undefined)) ? 'block' : 'none'
                                }}>
                                  <Col sm="12" className='col-selected-1' style={{ border: "solid 1px #ecf3fa", height: "60px" }}>
                                    <Row className='pt-2' >
                                      <Col sm="3" className='pt-2'>
                                        <div className='card-validateFinance-TC'>
                                          <b className='f-12'>T.C</b>
                                        </div>
                                      </Col>
                                      <Col sm="9">
                                        {listMovements?.map((movement) => {
                                          if (movement.id_pay_method === 2 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-primary'>
                                                <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                        {listMovementsInvoice?.map((movement) => {
                                          if (movement.id_pay_method === 2 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-danger pt-2'>
                                                <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                      </Col>
                                    </Row>
                                  </Col>
                                </Col>
                                <Col sm="2" className='pt-3' style={{
                                  display: (
                                    listMovements?.some(movement => movement.id_pay_method === 4 && movement.amount !== null && movement.amount !== undefined) ||
                                    listMovementsInvoice?.some(movement => movement.id_pay_method === 4 && movement.amount !== null && movement.amount !== undefined)) ? 'block' : 'none'
                                }}>
                                  <Col sm="12" className='col-selected-1' style={{ border: "solid 1px #ecf3fa", height: "60px" }}>
                                    <Row className='pt-2' >
                                      <Col sm="3" className='pt-2'>
                                        <div className='card-validateFinance-TD'>
                                          <b className='f-12'>T.D</b>
                                        </div>
                                      </Col>
                                      <Col sm="9">
                                        {listMovements?.map((movement) => {
                                          if (movement.id_pay_method === 4 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-primary'>
                                                <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                        {listMovementsInvoice?.map((movement) => {
                                          if (movement.id_pay_method === 4 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-danger pt-2'>
                                                <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                      </Col>
                                    </Row>
                                  </Col>
                                </Col>

                                <Col sm="2" className='pt-3' style={{
                                  display: (
                                    listMovements?.some(movement => movement.id_pay_method === 8 && movement.amount !== null && movement.amount !== undefined) ||
                                    listMovementsInvoice?.some(movement => movement.id_pay_method === 8 && movement.amount !== null && movement.amount !== undefined)) ? 'block' : 'none'
                                }}>
                                  <Col sm="12" className='col-selected-1' style={{ border: "solid 1px #ecf3fa", height: "60px" }}>
                                    <Row className='pt-2' >
                                      <Col sm="3" className='pt-2'>
                                        <div className='card-validateFinance-TE '>
                                          <b className='f-12'>T.E</b>
                                        </div>
                                      </Col>
                                      <Col sm="9">
                                        {listMovements?.map((movement) => {
                                          if (movement.id_pay_method === 8 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-primary'>
                                                <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                        {listMovementsInvoice?.map((movement) => {
                                          if (movement.id_pay_method === 8 && movement.amount !== null && movement.amount !== undefined) {
                                            return (
                                              <div key={movement.id_pay_method} className='txt-danger pt-2'>
                                                <b style={{ fontSize: "11px" }}> ${number_format(movement.amount, 2)}</b>
                                              </div>
                                            );
                                          }
                                          return null;
                                        })}
                                      </Col>

                                    </Row>
                                  </Col>
                                </Col>
                              </Row>
                              {
                                isComplement ? ""
                                  // <Col sm="12" >
                                  //   <Col sm="12">
                                  //     <Row>
                                  //       <Col sm="11">
                                  //         <h5>Montos </h5>
                                  //       </Col>
                                  //       <Col sm="1" className='p-l-0' >
                                  //         <div onClick={() => handleClosedViewDetalil()} id='btn-tooltip-excel' className='icon-div-user bg-dark pointer'  >
                                  //           <i className="icofont icofont-ui-close" ></i>
                                  //         </div>
                                  //       </Col>
                                  //     </Row>
                                  //   </Col>
                                  //   <Col sm="11" className='pt-3 p-l-0 p-r-0'>
                                  //     <div className='table-wrapper-finance'>
                                  //       <Table className='b-r-5 table table-xs'>
                                  //         <thead className='b-r-5'>
                                  //           <tr style={{ backgroundColor: "#f3f3f3", borderBottom: "#e3ebf3", borderTop: "#e3ebf3" }}>
                                  //             <th style={{ textAlign: "center" }}>Fecha</th>
                                  //             <th style={{ textAlign: "center" }}>Folio</th>
                                  //             <th style={{ textAlign: "center" }}>Receptor</th>
                                  //             <th style={{ textAlign: "center" }}>Monto</th>
                                  //             <th style={{ textAlign: "center" }}>UUID</th>
                                  //             <th style={{ textAlign: "center" }}>F. de Pago</th>
                                  //           </tr>
                                  //         </thead>
                                  //         <tbody style={{ textAlign: "center" }}>
                                  //           {dataComplement?.map((_find, _key) => {
                                  //             return (
                                  //               <tr key={_key}>
                                  //                 <td style={{ border: " 1px solid #e3ebf3", alignContent: "center" }}>{_find.payment_date ?? "-----"}</td>
                                  //                 <td style={{ border: " 1px solid #e3ebf3", alignContent: "center" }}>
                                  //                   <Col sm="12" className='badge-detail-Finance' >
                                  //                     <i className="fa fa-angle-right f-12"></i> {_find?.folio ?? "--"}
                                  //                   </Col>
                                  //                 </td>
                                  //                 <td style={{ border: " 1px solid #e3ebf3", alignContent: "center" }} >
                                  //                   {_find?.nameBussines ?? "----"}
                                  //                 </td>
                                  //                 <td style={{ border: " 1px solid #e3ebf3", alignContent: "center" }} >
                                  //                   ${number_format(_find?.payment_amount, 2) ?? ""}
                                  //                 </td>
                                  //                 <td style={{ border: " 1px solid #e3ebf3", alignContent: "center" }}>{_find.uuid ?? "-----"}</td>
                                  //                 <td style={{ border: " 1px solid #e3ebf3", alignContent: "center" }} >
                                  //                   <Col sm="12" className='badge-detail-Finance-Complement'>
                                  //                     <i className="fa fa-angle-right f-12"></i>{_find?.folioReceptor ?? "-----"}
                                  //                   </Col>
                                  //                 </td>
                                  //               </tr>
                                  //             );
                                  //           })}
                                  //           {totalRowComplement}
                                  //         </tbody>
                                  //       </Table>
                                  //     </div>
                                  //   </Col>
                                  // </Col>
                                  :
                                  <Row>
                                    <Col sm="12" style={{ position: 'relative', zIndex: 1 }}>
                                      <Row style={{ position: 'absolute', top: 0, left: 0, right: 0 }} >
                                        <Col sm="4">
                                        </Col>
                                        <Col sm="5">
                                        </Col>
                                        <Col sm="2"> <br /> <br /> <br />
                                          <Col sm="12" className={arrayDeposits.length > 0 ? 'col-selected-1 ' : "d-none"} style={{ border: "solid 1px #2c323f", height: "60px", zIndex: 20 }}>
                                            <Row className='pt-2' >
                                              <Col sm="3" className='pt-2' onClick={showModalBanking} >
                                                <div className='card-validateFinance-MP ' style={{ backgroundColor: "#002940" }} >
                                                  <b className='f-12'>D</b>
                                                </div>
                                              </Col>
                                              <Col sm="9">
                                                <label className='f-w-500' >Deposito bancario</label> <br />
                                                <b>${number_format(arrayDeposits.reduce((acc, curr) => acc + (curr?.amount ?? 0), 0), 2)}</b>
                                              </Col>
                                            </Row>
                                          </Col> <br />
                                          <Col sm="12" className={dataCortesy.length > 0 ? 'col-selected-1 ' : "d-none"} style={{ border: "solid 1px #2c323f", height: "60px", zIndex: 20 }}>
                                            <Row className='pt-2' >
                                              <Col sm="3" className='pt-2' onClick={showModalMembresia}>
                                                <div className='card-validateFinance-MP ' style={{ backgroundColor: "#c90013" }} >
                                                  <b className='f-12'>M</b>
                                                </div>
                                              </Col>
                                              <Col sm="9">
                                                <label className='f-w-500' >Membresia</label> <br />
                                                <b>${number_format(dataCortesy.reduce((acc, curr) => acc + (curr?.amount ?? 0), 0), 2)}</b>
                                              </Col>
                                            </Row>
                                          </Col>
                                          <Col >
                                          </Col>

                                        </Col>



                                        <Col sm="1">
                                        </Col>
                                      </Row>
                                      <Col sm="12" className='pt-1'>
                                        <Row>
                                          <Col sm="2" style={{ borderRight: "solid 1px #ecf3fa" }} >
                                            <Col sm="12" className=' p-r-0 pb-3' >
                                              <Row>
                                                <Col sm="6">
                                                  <i className="fa fa-circle txt-primary"></i>
                                                  <label className='' >Ingresado</label>
                                                </Col>
                                                <Col sm="6">
                                                  <i className="fa fa-circle txt-danger"></i>
                                                  <label className='' >Facturado</label>
                                                </Col>
                                              </Row>
                                            </Col>

                                            <Col sm="12" className=' p-r-0' >
                                              <label htmlFor="">Fecha inicio</label>
                                              <FormGroup>
                                                <Input
                                                  style={{ borderColor: "#fff", borderStyle: "solid", borderWidth: "1px", borderRadius: "15px", height: "35px", width: "200px", fontSize: "11px" }}
                                                  type='date'
                                                  name='start_date'
                                                  value={start_date}
                                                  onChange={(e) => handleInputChange(e)}
                                                >
                                                </Input>
                                              </FormGroup>
                                              <label htmlFor="">Fecha fin</label>
                                              <FormGroup>
                                                <Input
                                                  style={{ borderColor: "#fff", borderStyle: "solid", borderWidth: "1px", borderRadius: "15px", height: "35px", width: "200px", fontSize: "11px" }}
                                                  type='date'
                                                  name='end_date'
                                                  value={end_date}
                                                  onChange={(e) => handleInputChange(e)}
                                                >
                                                </Input>
                                              </FormGroup>

                                            </Col>


                                          </Col>

                                          <Col sm="8">
                                            {
                                              loadingDeposits ?
                                                <Row>
                                                  <Col sm="12" md="12" lg="12" className='text-center'>
                                                    <img alt='modal-preview' src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "8%" }} />
                                                  </Col>
                                                  <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                                    <p>Cargando ...</p>
                                                  </Col>
                                                </Row>

                                                :
                                                <ApexCharts id="chart-currently" options={CurrentlyDeposits2.options} series={CurrentlyDeposits2.series} type='area' height={250} />


                                            }

                                          </Col>

                                        </Row>
                                      </Col>


                                    </Col>



                                  </Row>
                              }
                              <Col sm="12" className=''>
                                <Row>
                                  <Col sm="2">
                                    <Col sm="12"  >
                                      <button
                                        onClick={() => handleActions()}
                                        disabled={loadingDeposits}
                                        style={{
                                          backgroundColor: loadingDeposits ? "#6c757d" : '#000',
                                          color: '#fff',
                                          border: 'none',
                                          padding: '8px 50px',
                                          fontSize: '10px',
                                          borderRadius: '5px',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        {!loadingDeposits && <i className='icofont icofont-filter f-10' style={{ marginRight: '5px' }}></i>}
                                        {loadingDeposits ? (
                                          <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" />
                                            Buscando...
                                          </>
                                        ) : (
                                          "Buscar"
                                        )}

                                      </button>
                                    </Col>
                                  </Col>
                                  <Col sm="3" className='p-r-0 '>
                                    <Row>
                                      <Col sm="3">
                                        <div id='btn-tooltip-excel' className='icon-div-user bg-danger pointer' >
                                          <i className="icofont icofont-cur-dollar f-18"></i>
                                        </div>
                                      </Col>
                                      <Col sm="9">
                                        <label className=''>Total Facturado</label> <br />
                                        <b style={{ fontSize: "13px" }}> ${number_format(indicatorAmountInvoice, 2)}</b>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col sm="3" className='p-l-0 p-r-0'>
                                    <Row>
                                      <Col sm="3" onClick={handlePayment} >
                                        <div className={isComplement ? 'icon-div-user bg-dark pointer' : 'icon-div-user bg-secondary pointer'}  >
                                          <i className={isComplement ? "icofont icofont-ui-close" : "icofont icofont-cur-dollar f-18"} ></i>

                                        </div>
                                      </Col>
                                      <Col sm="9">
                                        <label className=''>Ingreso de otros meses</label> <br />
                                        <b style={{ fontSize: "13px" }}> ${number_format(totalComplement, 2)}</b>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col sm="2" className='p-r-0 p-l-0' >
                                    <Row>
                                      <Col sm="3">
                                        <div id='btn-tooltip-excel' className='icon-div-user bg-danger pointer' onClick={showModalCancel}  >
                                          <i className="fa fa-times f-18"></i>
                                        </div>
                                      </Col>
                                      <Col sm="9">
                                        <label className=''>Ingreso Cancelado</label> <br />
                                        <b style={{ fontSize: "13px" }}> ${number_format(countPatient, 2)}</b>
                                      </Col>
                                    </Row>
                                  </Col>
                                  {
                                    _valid_Finance === "True" ? null :

                                      <Col sm="2" className='p-r-0 p-l-0'>
                                        <Row>
                                          <Col sm="3">
                                            <div id='btn-tooltip-excel' className='icon-div-user bg-info pointer' >
                                              <i className="fa fa-users f-18"></i>
                                            </div>
                                          </Col>
                                          <Col sm="9">
                                            <label className='f-w-600'>Total de pacientes</label> <br />
                                            <b style={{ fontSize: "13px" }} >{indicatorPatient}</b>
                                          </Col>
                                        </Row>
                                      </Col>
                                  }
                                </Row>
                              </Col>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm="12" className='p-l-0 p-r-0' >
                        <Toolbar left={leftContents} />
                      </Col>
                    </Row >
                  }


                  {
                    !valid_view &&
                    <Col sm="12" className={_validationFinance ? 'd-none' : 'pt-1 pt-2 p-l-0 p-r-0'}  >
                      <DataTable
                        value={formattedData}
                        rowGroupMode="subheader"
                        groupRowsBy="branchName"
                        sortMode="single"
                        sortField="branchName"
                        sortOrder={1}
                        className="data-table"
                        scrollable
                        scrollHeight="600px"
                        rowGroupHeaderTemplate={headerTemplate}
                        tableStyle={{ minWidth: '80rem' }}
                      >
                        <Column field="branchName" header="Sucursal" body={() => null} style={{ display: 'none' }} />
                        <Column
                          field="payments"
                          header="Métodos de Pago"
                          body={paymentBodyTemplate}
                          headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "10px",
                          }}
                          style={{
                            fontSize: "12px",
                            width: "30%",
                          }}
                        />
                      </DataTable>
                    </Col>
                  }
                  {
                    valid_view &&
                    <ModalCredit

                      companyInfo={companyInfo}
                      formatter={formatter}
                      navigateNim={navigateNim}
                      valid_view={valid_view}
                      cancellPatient={cancellPatient}
                      countPatient={countPatient}
                      exportToExcelCancell={exportToExcelCancell}
                      handleClosedView={handleClosedView}
                    >
                    </ModalCredit>
                  }
                </Col >
              )}
              {
                activeIndex === 1 && (
                  <Col sm="12" style={{ textAlign: "left" }} className="height-equal pricingtable pt-0 pb-0 pr-0 pl-0">
                    <Col sm="12" className='p-l-0 p-r-0' >
                      <div style={{
                        borderRadius: "8px 8px 0 0", padding: "15px", color: "#000000ff"
                      }}>

                        <Col sm="12" className='p-l-0 p-r-0' >
                          <Row>
                            <Col sm="3">
                              <label htmlFor="">Buscar deposito bancario </label> &nbsp;&nbsp;
                              <button
                                onClick={() => GetDeposits()}
                                style={{ backgroundColor: "#000", color: "#fff", borderRadius: "15px", padding: "10px", fontSize: "12px" }}
                              >
                                <i className='icofont icofont-filter f-14' ></i>Buscar
                              </button>
                            </Col>
                            <Col sm="6">
                            </Col>
                            <Col sm="3">
                              <label htmlFor="">Generar nuevo deposito bancario</label>&nbsp;&nbsp;
                              <button
                                onClick={() => saveReceived()}
                                style={{ backgroundColor: "#000", color: "#fff", borderRadius: "15px", padding: "10px", fontSize: "12px" }}
                              >
                                Guardar
                              </button>
                            </Col>
                          </Row>

                        </Col>
                      </div>
                      <Col sm="12" className=' p-r-0 pt-1' >
                        <Row className='pb-5' >
                          <Col sm="4">
                            <Calendar
                              onChange={onChange}
                              value={date}
                              tileClassName={tileClassName}
                              className="p-t-0 p-b-0"
                              locale="es-ES"

                            />
                          </Col>
                          <Col sm="8"  >
                            <Col sm="11" className='pb-2 p-r-0' >
                              <div
                                style={{
                                  color: "#856404",
                                  fontSize: "0.78rem",
                                  marginTop: "6px",
                                  fontWeight: "500",
                                  backgroundColor: "#fff3cd",
                                  padding: "4px 10px",
                                  borderRadius: "6px",
                                  boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  border: "1px solid #ffeeba",
                                }}
                              >
                                <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                                {"Estos depositos seran visibles en el dashboard y no podran ser editados nuevamente." ?? "---"}
                              </div>
                            </Col>
                            {
                              validNotification === false ?
                                <Col sm="12" className={disabledSaveButton === true ? "disabled disableLabel" : ""}>
                                  <Row>
                                    <Col sm="5">
                                    </Col>
                                    <Col sm="3"  >

                                    </Col>
                                    <Col sm="3" className='p-r-0'  >
                                      {
                                        one === true ? "" : <input type='date' className={`form-control form-control-sm input-air-primary ${(validationsSG.received ? 'b' : '')}`} name='date_1' value={date_1} onChange={(e) => handleInputChange(e)}></input>
                                      }
                                    </Col>

                                  </Row>
                                  <Row className='pt-4' >
                                    <Col sm="4">
                                      <label htmlFor="f-14">Quien recibio:<span className='f-20' style={{ color: "#0079C7" }}>*</span></label> <br />
                                      <input type='text' className='form-control form-control-sm input-air-primary' style={{ height: "35px", borderRadius: "15px", fontSize: "11px" }} name='received' value={received} onChange={(e) => handleInputChange(e)}  ></input>
                                    </Col>
                                    <Col sm="4">
                                      <label className='f-14' >Quien entrego:<span className='f-20' style={{ color: "#0079C7" }}>*</span></label> <br />
                                      <input type='text' className='form-control form-control-sm input-air-primary' style={{ height: "35px", borderRadius: "15px", fontSize: "11px" }} name='delivere' value={delivere} onChange={(e) => handleInputChange(e)} ></input>

                                    </Col>
                                    <Col sm="2">
                                      <label htmlFor="">Total a depositar:<span className='f-20' style={{ color: "#0079C7" }}>*</span></label>
                                      <input type='text' style={{ borderRadius: "15px", height: "35px", width: "200px", fontSize: "11px" }} className='form-control form-control-sm input-air-primary' name='amount' value={amount} onChange={(e) => handleInputChange(e)} ></input>
                                    </Col>
                                  </Row>
                                  <Row className='pt-4' >
                                    <Col sm="11" className='p-r-0' >
                                      <label htmlFor="">Observaciones</label>
                                      <textarea
                                        className='form-control form-control-sm input-air-primary '
                                        name="observation"
                                        rows="3"
                                        value={observation}
                                        onChange={handleInputChange}
                                      >
                                      </textarea>
                                    </Col>


                                  </Row>
                                </Col>
                                :
                                <Col sm="12" className={disabledSaveButton === true ? "disabled disableLabel" : ""}>
                                  <Row>
                                    <Col sm="5">
                                    </Col>
                                    <Col sm="3"  >
                                      {
                                        range === true ? <input type='date' className={`form-control form-control-sm input-air-primary ${(validationsSG.received ? '' : '')}`} name='date_2' value={date_2} onChange={(e) => handleInputChange(e)}></input> : ""
                                      }
                                    </Col>
                                    <Col sm="3"  >
                                      {
                                        one === true ? "" : <input type='date' className={`form-control form-control-sm input-air-primary ${(validationsSG.received ? 'b' : '')}`} name='date_1' value={date_1} onChange={(e) => handleInputChange(e)}></input>
                                      }
                                    </Col>

                                  </Row>
                                  <Row className='pt-4' >
                                    <Col sm="4">
                                      <label htmlFor="">Quien recibio:<span className='f-20' style={{ color: "#0079C7" }}>*</span></label> <br />
                                      <input type='text' className='form-control form-control-sm input-air-primary' style={{ height: "35px", borderRadius: "15px", fontSize: "11px" }} name='received' value={received} onChange={(e) => handleInputChange(e)}  ></input>
                                    </Col>
                                    <Col sm="4">
                                      <label className='f-14' >Quien entrego:<span className='f-20' style={{ color: "#0079C7" }}>*</span></label> <br />
                                      <input type='text' className='form-control form-control-sm input-air-primary' style={{ height: "35px", borderRadius: "15px", fontSize: "11px" }} name='delivere' value={delivere} onChange={(e) => handleInputChange(e)} ></input>

                                    </Col>
                                    <Col sm="2">
                                      <label htmlFor="">Total a depositar:<span className='f-20' style={{ color: "#0079C7" }}>*</span></label>
                                      <input type='text' style={{ borderRadius: "15px", height: "35px", width: "200px", fontSize: "11px" }} className='form-control form-control-sm input-air-primary' name='amount' value={amount} onChange={(e) => handleInputChange(e)} ></input>
                                    </Col>
                                  </Row>
                                  <Row className='pt-4' >
                                    <Col sm="6">
                                      <label htmlFor="">Observaciones</label>
                                      <textarea
                                        className='form-control form-control-sm input-air-primary '
                                        name="observation"
                                        rows="3"
                                        value={observation}
                                        onChange={handleInputChange}
                                      >
                                      </textarea>

                                    </Col>
                                    <Col sm="2">
                                    </Col>
                                    <Col sm="4" className='pt-5' style={{ textAlign: "end" }} >
                                      <Media body className="rounded-circle" style={{ width: "40%" }} src={require("../../assets/images/loginHelenLabs/User/UserWoman.svg")} alt="" />

                                    </Col>

                                  </Row>
                                </Col>
                            }
                          </Col>
                        </Row>
                      </Col>

                    </Col>
                  </Col>
                )
              }
              {
                activeIndex === 2 && (
                  <Col sm="12" className='p-l-0 p-r-0' >
                    <div style={{ textAlign: "left" }} className="height-equal pricingtable pt-0 pb-0 pr-0 pl-0">
                      <div >
                        <div style={{ borderRadius: "8px 8px 0 0", padding: "2px", color: "#000", boxShadow: "0 4px 8px rgba(0,0,0,0.2)" }}>
                          <br />
                          <Col sm="5" className="pb-4">
                            <div
                              style={{
                                color: "#856404",
                                fontSize: "0.78rem",
                                marginTop: "6px",
                                fontWeight: "500",
                                backgroundColor: "#fff3cd",
                                padding: "4px 10px",
                                borderRadius: "6px",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                border: "1px solid #ffeeba",
                              }}
                            >
                              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                              {"Estos son pacientes que en algún momento solicitaron factura." ?? "---"}
                            </div>
                          </Col>
                          <Col sm="12">
                            <Row>
                              <Col sm="2"  >
                                <label htmlFor="">Selecciona la sucursal</label> <br />
                                <FormGroup>
                                  <Input
                                    style={{ borderColor: "#5bbfff", borderStyle: "solid", borderWidth: "1px", borderRadius: "15px", height: "35px", width: "200px", fontSize: "11px", }}
                                    type='select'
                                    name="id_tax_regime_business_name"
                                    onChange={(e) => handleSelectBranch(e.target.value)}
                                  >
                                    <option value={0}>Selecciona una sucursal</option>
                                    {invoiceBranch.length > 0 && invoiceBranch.map(_branch => (
                                      <option key={`branchs-${_branch.value}`} value={_branch.value}>{_branch.label}</option>
                                    ))}
                                  </Input>
                                </FormGroup>
                                {
                                }
                              </Col>
                              <Col sm="2" className='p-l-0 ' >
                                <label htmlFor="">Selecciona el periodo</label> <br />
                                <FormGroup>
                                  <Input
                                    style={{ borderColor: "#5bbfff", borderStyle: "solid", borderWidth: "1px", borderRadius: "15px", height: "35px", width: "200px", fontSize: "11px" }}
                                    type='select'
                                    name="id_tax_regime_business_name"
                                    onChange={(e) => handleSelectMonth(e.target.value)}
                                  >
                                    <option value={0}>Selecciona una periodo</option>
                                    {monthInvoices.length > 0 && monthInvoices.map(_month => (
                                      <option key={`monthIn-${_month.value}`} value={_month.value}>{_month.label}</option>
                                    ))}
                                  </Input>
                                </FormGroup>
                              </Col>
                              <Col sm="2">
                                <label htmlFor="">Selecciona el año</label> <br />
                                <FormGroup>
                                  <Input
                                    style={{ borderColor: "#5bbfff", borderStyle: "solid", borderWidth: "1px", borderRadius: "15px", height: "35px", width: "200px", fontSize: "11px" }}
                                    type='select'
                                    name="id_tax_regime_business_name"
                                    onChange={(e) => handleSelectAge(e.target.value)}
                                  >
                                    <option value={0}>Selecciona el año</option>
                                    <option value={"2024"}>2024</option>
                                    <option value={"2025"}>2025</option>
                                    <option value={"2026"}>2026</option>


                                  </Input>
                                </FormGroup>
                              </Col>
                              <Col sm="2">
                                <label className='f-w-500' >Filtrar método de pago</label> <br />
                                <select
                                  style={{ borderColor: "#5bbfff", borderStyle: "solid", borderWidth: "1px", borderRadius: "15px", height: "35px", width: "200px", fontSize: "11px" }}
                                  onChange={(e) => setSelectedPaymentMethod(Number(e.target.value))}>
                                  <option value="">Todos los métodos de pago</option>
                                  {Object.keys(paymentMethods).map(key => (
                                    <option key={key} value={key}>{paymentMethods[key]}</option>
                                  ))}
                                </select>

                              </Col>

                              <Col sm="1" className='pt-4' style={{ textAlign: "end" }} >
                                <button onClick={() => getInformationInvoices()} style={{ backgroundColor: "#000", color: "#fff", borderRadius: "15px", padding: "10px", fontSize: "12px" }}>
                                  <i className='icofont icofont-filter f-14' ></i>Buscar
                                </button>
                              </Col>
                              <Col sm="1" className={listInvoices.length > 0 ? 'pt-4' : "d-none"} >
                                <button onClick={() => handleInvoices()} style={{ backgroundColor: "#002940", color: "#fff", borderRadius: "15px", padding: "10px", fontSize: "12px" }}>
                                  Guardar
                                </button>
                              </Col>
                              <Col sm="1" className={listInvoices.length > 0 ? 'pt-4 p-l-0' : "d-none"}  >

                              </Col>
                            </Row>
                          </Col>
                        </div>
                      </div>
                      <div>
                        <Col sm="12" className='p-l-0 p-r-0 pt-1 pb-5'   >
                          <Table striped size='xs'>
                            <thead>
                              <tr>
                                <th style={{ backgroundColor: "#0e618bfc", color: "#fff", fontWeight: "bold" }}>#</th>
                                <th style={{ backgroundColor: "#002940d1", color: "#fff", fontWeight: "bold", alignItems: 'center', justifyContent: 'space-between' }}>
                                  <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                    style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                                  />
                                </th>
                                <th style={{ backgroundColor: "#0e618bfc", color: "#fff", fontWeight: "bold" }}>Nim</th>
                                <th style={{ backgroundColor: "#0e618bfc", color: "#fff", fontWeight: "bold" }}>Nombre</th>
                                <th style={{ backgroundColor: "#0e618bfc", color: "#fff", fontWeight: "bold" }}>Sucursal</th>
                                <th style={{ backgroundColor: "#0e618bfc", color: "#fff", fontWeight: "bold" }}>Fecha</th>
                                <th style={{ backgroundColor: "#0e618bfc", color: "#fff", fontWeight: "bold" }}>Solicito factura</th>
                                <th style={{ backgroundColor: "#0e618bfc", color: "#fff", fontWeight: "bold" }}>Método de pago</th>
                                <th style={{ backgroundColor: "#0e618bfc", color: "#fff", fontWeight: "bold" }}>Total</th>
                              </tr>
                            </thead>
                            <tbody >
                              {
                                filteredInvoices.length === 0 && (<tr><td colSpan="8" style={{ textAlign: "center" }}>
                                  <div className="text-center">
                                    <img
                                      src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                      style={{ width: "25%" }}
                                      alt="Sin resultados"
                                    />
                                    <br />
                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "11px" }}>Sin inforamción disponible.</p>
                                  </div>
                                </td></tr>)

                              }
                              {filteredInvoices.length > 0 && filteredInvoices.map((_invoice, index) => {
                                // ? TYPE METHOD
                                let _namePayMethod;
                                const payMethod = Array.isArray(_invoice?.pay_methods) ? _invoice?.pay_methods[0] : _invoice?.pay_methods;

                                switch (payMethod) {
                                  case 1:
                                    _namePayMethod = "Efectivo";
                                    break;
                                  case 2:
                                    _namePayMethod = "Tarjeta de Crédito";
                                    break;
                                  case 4:
                                    _namePayMethod = "Tarjeta de Débito";
                                    break;
                                  case 8:
                                    _namePayMethod = "Transferencia Electrónica";
                                    break;
                                  case 10:
                                    _namePayMethod = "Crédito";
                                    break;
                                  case 27:
                                    _namePayMethod = "Método PPD";
                                    break;
                                  case 31:
                                    _namePayMethod = "Bonificación";
                                    break;
                                  case 7:
                                    _namePayMethod = "Cheque nominativo";
                                    break;
                                  default:
                                    _namePayMethod = "Mercado Pago";
                                }

                                const idWorkOrder = _invoice?.id_work_order;
                                const isChecked = !!checkedItems[idWorkOrder];

                                return (
                                  <tr key={_invoice?.nimm}>
                                    <th className={isChecked ? 'selected' : ''}>{index + 1}</th>
                                    <th style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        id={`checkbox-${idWorkOrder}`}
                                        checked={!!checkedItems[idWorkOrder]}
                                        onChange={() => handleCheckboxChange(idWorkOrder)}
                                        style={{ display: 'none' }}
                                      />
                                      <label htmlFor={`checkbox-${idWorkOrder}`} style={{
                                        display: 'inline-block',
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: '50%',
                                        border: `2px solid #065c88`,
                                        backgroundColor: 'transparent',
                                        cursor: 'pointer',
                                        position: 'relative'
                                      }}>
                                        <span style={{
                                          position: 'absolute',
                                          top: '50%',
                                          left: '50%',
                                          width: '12px',
                                          height: '12px',
                                          backgroundColor: '#065c88',
                                          borderRadius: '50%',
                                          transform: 'translate(-50%, -50%)',
                                          opacity: checkedItems[idWorkOrder] ? 1 : 0,
                                          transition: 'opacity 0.2s'
                                        }}></span>
                                      </label>
                                    </th>
                                    <th style={{ color: "#6c757d" }} className={isChecked ? 'selected' : ''} >{_invoice?.nimm}</th>
                                    <th className={isChecked ? 'selected' : ''}> <b style={{ color: "#1e73a9" }} > {_invoice?.name}</b></th>
                                    <th style={{ color: "#6c757d" }} className={isChecked ? 'selected' : ''}>{_invoice?.branch}</th>
                                    <th style={{ color: "#6c757d" }} className={isChecked ? 'selected' : ''}>{_invoice?.fech}</th>
                                    <th className={isChecked ? 'selected' : ''} style={{ textAlign: "center" }}>{_invoice?.invoices ? <i className='fa fa-check txt-success f-14'></i> : null}</th>
                                    <th style={{ color: "#6c757d" }} className={isChecked ? 'selected' : ''}>{_namePayMethod}</th>
                                    <th style={{ color: "#6c757d" }} className={isChecked ? 'selected' : ''}>${number_format(_invoice?.amount ?? 0, 2)}</th>
                                  </tr>
                                );
                              })}
                              {invoicesAmount2}
                            </tbody>
                          </Table>

                        </Col>
                      </div>

                    </div>

                  </Col>
                )
              }
            </Card >


          </Col >
        </div >
      }
    </Fragment >
  )
}